import React from 'react';
import RepuestoItem from './RepuestoItem';

/**
 * Componente para mostrar una lista de repuestos con espaciado óptimo
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.repuestos - Lista de repuestos a mostrar
 * @param {Array} props.sucursales - Lista de sucursales disponibles
 * @param {Array} props.categorias - Lista de categorías disponibles
 * @param {function} props.onEdit - Función para editar un repuesto
 * @param {function} props.onAdjustStock - Función para ajustar el stock de un repuesto
 * @param {function} props.onDelete - Función para eliminar un repuesto
 * @returns {JSX.Element} - Componente de lista de repuestos
 */
const RepuestosList = ({ repuestos = [], sucursales = [], categorias = [], onEdit, onAdjustStock, onDelete }) => {
  if (repuestos.length === 0) {
    return (
      <div className="text-center p-4 bg-gray-800 rounded text-gray-400">
        No hay repuestos registrados. Agrega uno para comenzar.
      </div>
    );
  }

  return (
    <div>
      <ul className="mt-4 space-y-3">
        {repuestos.map(repuesto => (
          <RepuestoItem
            key={repuesto.id}
            repuesto={repuesto}
            sucursales={sucursales}
            categorias={categorias}
            onEdit={onEdit}
            onAdjustStock={onAdjustStock}
            onDelete={onDelete}
          />
        ))}
      </ul>
    </div>
  );
};

export default RepuestosList;